import Breadcrumb from 'Components/UI/Breadcrumb';
import React, { useState } from 'react'
import { Button, Card, CardBody, CardTitle, Col, Container, Form, Input, Label, Row, FormFeedback } from "reactstrap";
import * as yup from "yup";
import { useFormik } from "formik";
import Editor from 'Components/Form/Editor/Editor';
import { createCategory } from 'helpers/API Calls/Operations/category';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Dropzone from 'Components/Form/DropZone';
import placeholderImage from "assets/images/img.png"

// Convert file to base64
export const convertToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = error => reject(error);
  });
};

function Create() {

  const navigate = useNavigate(); 
  const [content, setContent] = useState('')
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [imageBase64, setImageBase64] = useState<string>('');
  const [imageError, setImageError] = useState<string>('');


  const formik: any = useFormik({
    initialValues: {
      name: '',
      metaTitle: '',
      metaDesc: '',
      isAddon: false,
      // status: null, 
    },
    validationSchema: yup.object().shape({
      name: yup.string().required('Please enter category name.'),
      metaTitle: yup.string().optional(),
      metaDesc: yup.string().optional(),
      isAddon: yup.boolean(), 
      // status : yup.object().shape({label: yup.string().required(), value: yup.string().required(),}).nullable().required('Please select status'),
    }),
    onSubmit: async (values: any, { setSubmitting }) => {
      setSubmitting(true);
      const data = {
        category_name: values.name,
        meta_title: values.metaTitle,
        meta_description: values.metaDesc,
        description: content,
        is_addon: values.isAddon ? 1 : 0,
        category_image: imageBase64 || null,
        // status: values.status.value,
      }
      const response = await createCategory(data);
      setSubmitting(false);
      if(response.success){
        formik.resetForm();
        setContent(''); 
        navigate('/categories');
      }
    },
  });

  // Add scroll to error effect
  useEffect(() => {
    if (Object.keys(formik.errors).length > 0 && formik.isSubmitting) {
      const firstErrorKey = Object.keys(formik.errors)[0];
      const element = document.getElementById(firstErrorKey);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        element.focus();
      }
    }
  }, [formik.errors, formik.isSubmitting]);

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb items={[{ label: "Categories", link: "/categories" }, {label: 'Create'}]} />
        <Card>
          <CardBody>
            <Form onSubmit={formik.handleSubmit} autoComplete="off">
              <Row>
                <Col xl="8">
                <CardTitle tag="h4" className='mb-4'>Basic Details</CardTitle>
                  <div className="mb-3">
                    <Label htmlFor="name">Category Name <span className="text-danger">*</span></Label>
                    <Input
                      id="name"
                      name="name"
                      type="text"
                      placeholder="Category Name"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      invalid={formik.touched.name && formik.errors.name ? true : false}
                    />
                    {formik.errors.name && formik.touched.name ? (
                      <FormFeedback type="invalid">{formik.errors.name}</FormFeedback>
                    ) : null}
                  </div>

                  <div className="mb-3">
                    <Label>Content</Label>
                    <Editor content={content} setContent={setContent} />
                  </div>

                </Col>
                <Col xl="4">
                  <Row>
                    <CardTitle tag="h4" className='mb-4'>SEO Information</CardTitle>
                    <div className="mb-3">
                      <Label htmlFor="metaTitle">Meta Title</Label>
                      <Input
                        id="metaTitle"
                        name="metaTitle"
                        type="text"
                        placeholder="Meta Title"
                        value={formik.values.metaTitle}
                        onChange={formik.handleChange}
                        invalid={formik.touched.metaTitle && formik.errors.metaTitle ? true : false}
                      />
                      {formik.errors.metaTitle && formik.touched.metaTitle ? (
                        <FormFeedback type="invalid">{formik.errors.metaTitle}</FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label htmlFor="metaDesc">Meta Description</Label>
                      <Input
                        tag="textarea"
                        className="mb-3"
                        id="metaDesc"
                        name="metaDesc"
                        rows={5}
                        placeholder="Category Description"
                        value={formik.values.metaDesc}
                        onChange={formik.handleChange}
                        invalid={formik.touched.metaDesc && formik.errors.metaDesc ? true : false}
                      />
                      {formik.errors.metaDesc && formik.touched.metaDesc ? (
                        <FormFeedback type="invalid">{formik.errors.metaDesc}</FormFeedback>
                      ) : null}
                    </div>
                  </Row>
                  <Row>
                    <CardTitle tag="h4" className='mb-4'>Settings</CardTitle>
                    {/* <div className="mb-4">
                      <Label className="form-label">Status</Label>
                      <Select
                        name="status"
                        placeholder="Select Status"
                        options={STATUS_OPTIONS}
                        value={formik.values.status}
                        onChange={(value) => formik.setFieldValue("status", value)}
                        onBlur={formik.handleBlur}
                        className={
                          formik.touched.status && formik.errors.status
                            ? "is-invalid"
                            : ""
                        }
                      />
                      {formik.touched.status && formik.errors.status ? (
                        <FormFeedback type="invalid">{formik.errors.status || formik.errors.status}</FormFeedback>
                      ) : null}
                    </div> */}

                    <div className="mb-3">
                      <Label className="form-label">Category Type</Label>
                      <div className="form-check form-switch mb-3 form-switch-md">
                        <Input
                          type="switch"
                          className="form-check-input"
                          id="isAddon"
                          name="isAddon"
                          checked={formik.values.isAddon}
                          onChange={e => formik.setFieldValue("isAddon", e.target.checked)}
                        />
                        <Label className="form-check-label" htmlFor="isAddon">
                          Mark as Addon
                        </Label>
                      </div>
                    </div>
                    <Row>
                      {/* logo */}
                      <div className="mb-3" id="featured-image-section">
                        <Label htmlFor="name-input">Featured Image <span className="text-danger">*</span></Label>
                        <Dropzone
                          accept = {{"image/*": [".png", ".jpeg", ".jpg"]}}
                          onDrop = {async (acceptedFiles) => {
                            const file = acceptedFiles[0];
                            setSelectedImage(file);
                            setImageError('');
                            try {
                              const base64 = await convertToBase64(file);
                              setImageBase64(base64);
                            } catch (error) {
                              setImageError('Failed to process image');
                            }
                          }}
                          renderContent = {() => (
                            <div className="text-center cursor-pointer">
                              <div className="position-relative d-inline-block" >
                                <div className={`avatar-xl rounded`}>
                                  <div className="avatar-title bg-light ">
                                    <img
                                      src={selectedImage ? URL.createObjectURL(selectedImage) : placeholderImage}
                                      id="logo-img"
                                      alt=""
                                      className="avatar-xl rounded"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        />
                        {imageError && (
                          <div className="text-danger mt-1 small">{imageError}</div>
                        )}
                      </div>
                    </Row>
                  </Row>
                </Col>
              </Row>

              <div className="d-flex flex-wrap gap-2 mt-3 justify-content-end">
                <Button type="submit" color="primary"disabled={formik.isSubmitting}>{formik.isSubmitting ? 'Creating...' : 'Create Category'}</Button>
              </div>

            </Form>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default Create
